

















































































import { computed, defineComponent, ref, watch } from '@nuxtjs/composition-api'
import { numberArray } from '~/lib/utilities'

export default defineComponent({
  name: 'BasePagination',

  props: {
    limit: {
      type: Number,
      default: 12,
      required: true,
    },
    offset: {
      type: Number,
      default: 0,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
  },

  setup(props, { emit }) {
    const currentPage = ref(0)

    watch(
      [() => props.limit, () => props.offset],
      ([limit, offset]) => {
        currentPage.value = Math.floor(offset / limit) + 1
        // goto(Math.floor(offset / limit) + 1)
      },
      {
        immediate: true,
      }
    )

    const pages = computed(() => {
      if (props.limit <= 0) {
        return 0
      }
      return (
        Math.floor(props.total / props.limit) +
        (props.total % props.limit > 0 ? 1 : 0)
      )
    })

    const centerItemsSize = ref(3)

    const pageCenterItems = computed(() => {
      if (pages.value < 3) {
        return []
      }

      // This is to ensure we won't have
      // a single ommited page in between first and last
      // e.g. 1 ... 3, 4, 5 ... 16 should be 1, 2, 3, 4, 5 ... 16
      // e.g. 1 ... 7, 8, 9 ... 11 should 1 ... 7, 8, 9, 10, 11
      const paddedNumberArray = (from: number, to: number) => {
        const items = numberArray(from, to)

        if (items[0] === 3) {
          items.unshift(2)
        }
        if (items[items.length - 1] === pages.value - 2) {
          items.push(pages.value - 1)
        }
        return items
      }

      if (pages.value < centerItemsSize.value + 2) {
        return paddedNumberArray(2, pages.value - 1)
      }

      if (currentPage.value <= centerItemsSize.value) {
        return paddedNumberArray(
          2,
          Math.min(centerItemsSize.value + 1, pages.value - 1)
        )
      } else if (currentPage.value > pages.value - centerItemsSize.value) {
        return paddedNumberArray(
          Math.max(2, pages.value - centerItemsSize.value),
          pages.value - 1
        )
      } else {
        const from = currentPage.value - Math.floor(centerItemsSize.value / 2)
        const to = currentPage.value + Math.floor(centerItemsSize.value / 2)
        return paddedNumberArray(from, to)
      }
    })

    const showPreEllipses = computed(() => {
      return (
        pageCenterItems.value.length > 0 && !pageCenterItems.value.includes(2)
      )
    })

    const showNextEllipses = computed(() => {
      return (
        pageCenterItems.value.length > 0 &&
        !pageCenterItems.value.includes(pages.value - 1)
      )
    })

    const goto = (page: number) => {
      if (page < 1 || page > pages.value || page === currentPage.value) return

      currentPage.value = page
      const offset = (page - 1) * props.limit
      emit('page-change', page, offset)

      if (process.client) {
        window.scroll({
          top: 0,
          behavior: 'smooth',
        })
      }
    }

    const toPrev = () => {
      goto(currentPage.value - 1)
    }

    const toNext = () => {
      goto(currentPage.value + 1)
    }

    return {
      currentPage,
      pages,
      pageCenterItems,
      centerItemsSize,
      showPreEllipses,
      showNextEllipses,
      goto,
      toPrev,
      toNext,
    }
  },
})
